const SUPPORTED_LANGS = [
  "mr",
  "hi",
  "kn",
  "te",
  "pa",
  "gu",
  "en",
  "ta",
  "or",
  "bn",
  "ma",
];

export const resolveLang = (lang) =>
  SUPPORTED_LANGS.includes(lang) ? lang : "hi";

export const loginPath = (lang) => `/${resolveLang(lang)}/login`;
